import "./TimeLogShowView.scss";

import React from "react";
import { Link, Redirect } from "react-router-dom";
import request from "request";
import Flash from "flash";
import usesFeatures from "usesFeatures";
import { ApplicationContext } from "ApplicationContext";
import moment from "moment";

import Header from "Header";
import Card from "Card";
import { venueTimeZone, formatInZone } from "lib/venue_time_zone";

class TimeLogShowView extends React.Component {
  static contextType = ApplicationContext;

  state = { deleted: false };

  componentDidMount() {
    const id = this.props.computedMatch.params.id;
    this.props.fetchData(`venue_admin/time_logs/${id}`);
  }

  handleDelete = () => {
    if (!window.confirm("Delete this time log? This cannot be undone.")) return;
    const id = this.props.computedMatch.params.id;
    request.delete(`venue_admin/time_logs/${id}`).then(({ data }) => {
      if (data.success) {
        Flash.broadcast("success", "Time log deleted");
        this.setState({ deleted: true });
      } else {
        Flash.broadcast("error", "Failed to delete time log");
      }
    });
  };

  formatDuration = (startAt, endAt) => {
    if (!endAt) return "Active";

    const start = moment(startAt);
    const end = moment(endAt);
    const duration = moment.duration(end.diff(start));

    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();

    return `${hours} hours ${minutes} minutes`;
  };

  render() {
    if (this.state.deleted) return <Redirect to="/time_logs" />;
    if (!this.props.dataFetched) return false;

    const { timeLog } = this.props;
    const tz = venueTimeZone(this.context?.CurrentUserContext?.venue);
    const fmtAt = (iso) => formatInZone(iso, tz, "MMMM D, YYYY h:mm:ss A z");

    return (
      <div className="TimeLogShowView">
        <Header text="Time Log Details" />

        <div className="columns">
          <div className="column is-8">
            <Card title="Time Log Information">
              <div className="content">
                <table className="table is-fullwidth">
                  <tbody>
                    <tr>
                      <th>Employee</th>
                      <td>
                        <Link to={`/employees/${timeLog.employee.id}/edit`} target="_blank">
                          {timeLog.employee.name}
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <th>Store</th>
                      <td>{timeLog.employee.store?.name || <span className="has-text-grey-light">All Stores</span>}</td>
                    </tr>
                    <tr>
                      <th>Terminal</th>
                      <td>Terminal #{timeLog.terminal.number}</td>
                    </tr>
                    <tr>
                      <th>Clock In</th>
                      <td>{fmtAt(timeLog.startAt)}</td>
                    </tr>
                    <tr>
                      <th>Clock Out</th>
                      <td>
                        {timeLog.endAt ? (
                          fmtAt(timeLog.endAt)
                        ) : (
                          <span className="tag is-success">Still Active</span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th>Duration</th>
                      <td>
                        <strong>{this.formatDuration(timeLog.startAt, timeLog.endAt)}</strong>
                      </td>
                    </tr>
                    <tr>
                      <th>IP Address (Clock In)</th>
                      <td>
                        {timeLog.requestIpIn ? (
                          <code>{timeLog.requestIpIn}</code>
                        ) : (
                          <span className="has-text-grey-light">Not recorded</span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th>IP Address (Clock Out)</th>
                      <td>
                        {timeLog.requestIpOut ? (
                          <code>{timeLog.requestIpOut}</code>
                        ) : (
                          <span className="has-text-grey-light">Not recorded</span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th>Created At</th>
                      <td>{fmtAt(timeLog.createdAt)}</td>
                    </tr>
                    <tr>
                      <th>Updated At</th>
                      <td>{fmtAt(timeLog.updatedAt)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card>

            <div className="buttons">
              <Link to="/time_logs" className="button">
                Back to Time Logs
              </Link>
              <Link to={`/time_logs/${timeLog.id}/edit`} className="button is-primary">
                Edit
              </Link>
              <button type="button" onClick={this.handleDelete} className="button is-danger is-light">
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default usesFeatures(["data"], TimeLogShowView);
